import { useEffect, useState, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { DataGrid, NGODatePicker, EditModal } from "../../../common";
import { APIEndpoint, DFPAPIEndpoint } from "../../../utils/axios";
import {updateButtonTxtStatus,checkDownloadStatus,objectToQueryString, formatDateByTimezone,} from "../../../utils/commonFunctions";
import { MIMETypes, ORDER_PAYMENT_TYPE_LIST, ORDER_SALE_TYPE_LIST_DYNAMIC, ORDER_STATUS_LIST, customSelSearch} from "../../../utils/configs";
import * as ReactDOM from "react-dom";
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIn from '../../../assets/loadingIn.gif';
import downloadMasterIcon from "../../../assets/icons/download-master.svg";
import searchIcon from "../../../assets/icons/search.svg";
import viewIcon from "../../../assets/view.svg";
import usePermissions from '../../../utils/userPermissions';
import {SalesReportsDownloadComponent, SectorRenderer, OrderStatusRenderSel, PaymentTypeRenderSel, OrdNoRenderer} from "./renderers";
import CustomSelect from "../../../common/CustomSelect";
import checkDownloadStatusUtil from "../../../utils/checkDownloadStatus";
import {ThemeContext} from "../../../contexts/themeContext";

let axiosAbortCtrl = [];
axiosAbortCtrl["orderListAPI"] = new AbortController();

const newAbortSignal = (apiName, timeoutMs = 5000) => {

  axiosAbortCtrl[apiName] = new AbortController();
  // setTimeout(() => axiosAbortCtrl[apiName].abort(), timeoutMs || 0);

  return axiosAbortCtrl[apiName].signal;
};
const abortEarlierRequest = (apiName = "orderListAPI") => {
  axiosAbortCtrl[apiName].abort(
    apiName + ": Cancelling API running earlier..."
  );
};

const DATE_FORMAT = "DD-MM-YYYY"; // hh:mm A

const filterData = {
  action: 4,
  collection: "",
  filterOperation: "or",
  filters: [],
  limit: 50,
  page: 1,
  searchParam: "",
  sort: [{ field: "timestampDateTime", order: "desc" }],
};




const OrderByFilters = [
  // { field: 'timestampDateTime', order: 'asc' }
  { value: "orderDateDesc", label: "Order Date - Desc" },
  { value: "orderDateAsc", label: "Order Date - Asc" },
];


export const getOrderSaleType = (saleType) => {
  if (saleType) {
    return  ORDER_SALE_TYPE_LIST_DYNAMIC.find((_) => _.value === saleType)?.label || saleType;
};
}
export const ReconcilledPage = (props) => {
  const { t } = useTranslation();
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [buttonId, setButtonId] = useState(null);
  const [state, setState] = useState({message:null});

  const [perPageLimit] = useState(50);
  const [ isReloadTableData, setIsReloadTableData ] = useState(false);

  const [modalTitle, setModalTitle] = useState("Order Details");
  const [modalCustomButtons, setModalCustomButtons] = useState(null);
  const modelStyle = { maxWidth: '80%' };
  const [modalFormStatusObj] = useState({ text: '' });
  const [, setUpdatedFormFieldValues] = useState({});
  const [modalFormData, setModalFormData] = useState({});
  const [sectorList, setSectorsList] = useState([]);
  const [message, setMessage] = useState('No Data');
  const {themedColor} = useContext(ThemeContext);

  const savedFilters = JSON.parse(sessionStorage.getItem('pageFiltersFinalized')) || {
    sectorVal: [],
    orderByVal: OrderByFilters[0].value,
    orderDateVal: new Date(),
    searchKey: "",
    orderStatusVal: "",
    saleType: "",
    paymentType: "",
  };

  const [salesFilter, setSalesFilter] = useState(savedFilters);
  const ActionCell = (params)=>{

    return (
      <div className="flexRow">
      {params?.data?<div className="margRight10"> <button onClick={(e)=>onActionInner(e,{value:"viewItems"},params?.data)} title="View Items" className="margRight10">
          <img className="edit" alt="" src={viewIcon}/>
        </button></div>:null}

        {params?.data && params.data?.saleTypeRaw === "preBooked" &&
          params?.data?.orderStatus !== "Cancelled Order" && (<div className="margRight10">
            <button onClick={(e)=>onActionInner(e,{value:"downloadInvoices"},params?.data)} title="Download Invoices">
              <img className="edit" alt="" style={{width:'20px',height:'20px'}} src={isLoadingInvoice && buttonId===params?.data.id?LoadingIn:downloadMasterIcon}/>
            </button></div>

          )}
      </div>
    )
  }

  const Columns = [
    {
      field: "orderNo",
      headerName: "Sector",
      minWidth: 184,
      tooltipField: "flightNumber",
      autoHeight: true,
      pinned: "left",flex:1, suppressSizeToFit:true,
      cellRendererSelector: (params) => {
        return {
          component: SectorRenderer,
        };
      },
    },
    {
      field: "orderNo",
      headerName: "Order Number",
      resizable:true,
      minWidth: 260,
      tooltipField: "orderNo",
      autoHeight: true,flex:1, suppressSizeToFit:true,
      cellRendererSelector: (params) => {
        return {
          component: OrdNoRenderer,
        };
      },
    },
    {
      field: "timestampDateTime",
      headerName: "Order Date",
      resizeable:true,
      minWidth: 100,
      tooltipField: "timestampDateTime",
      autoHeight: true,flex:1, suppressSizeToFit:true,
      valueGetter: (params) => {
        return params.data?.timestampDateTime
          ? moment(params.data?.timestampDateTime).format(DATE_FORMAT)
          : "";
      },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      minWidth: 140,
      tooltipField: "orderStatus",
      autoHeight: true,flex:1, suppressSizeToFit:true,
      cellRendererSelector: (params) => {
        return {
          component: OrderStatusRenderSel,
        };
      },
    },
    {
      field: "saleTypeRaw",
      headerName: "Sale Type",
      minWidth: 150,
      autoHeight: true,flex:1, suppressSizeToFit:true,
      valueGetter: (params) => {
        return params.data ? getOrderSaleType(params.data.saleTypeRaw) : "";
      },
    },
    {
      field: "paymentTypeRaw",
      headerName: "Payment Type",
      minWidth: 160,
      // tooltipField: "paymentTypeRaw",
      autoHeight: true,flex:1, suppressSizeToFit:true,
      cellRendererSelector: (params) => {
        return {
          component: PaymentTypeRenderSel,
        };
      },
    },
    {
      field: "totalAmountInUsedCurrency",
      headerName: "Total Amount",
      minWidth: 160,
      autoHeight: true,flex:1, suppressSizeToFit:true,
      valueGetter: (params) => {
        return params.data
          ? params.data.currencyInfo.currencyCode + " " + params.data?.totalAmountInUsedCurrency
          : "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      cellRenderer:ActionCell,
      minWidth:150,
      pinned:"right"
    }
  ];

  const [sectorPageObj, setSectorPageObj] = useState({
    page: 1,
    size: 2000,
    q: "",
  });

  const [, setReportTypes] = useState([]);
  const [editFormFields, setEditFormFields] = useState([]);

  const { hasPermission: viewRecon } = usePermissions('viewDetails', 'sales.finalized');
  const { hasPermission: downloadRecon } = usePermissions('download', 'sales.finalized');


  useEffect(() => {
    getSectorList();

    loadReportTypes();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sessionStorage.setItem('pageFiltersFinalized', JSON.stringify(salesFilter));
    setIsReloadTableData(prev=>!prev);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesFilter]);

    useEffect(() => {
      if(state.message){
        showToast();
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

   const fetchOrders = useCallback(
    async (page = 1, perPage = 50) => {
      /**
       * Pagination
       */
      filterData.page = page;
      filterData.limit = perPage;

      /**
       * Filters
       */
       filterData.filters = [
        { orderNo: salesFilter.searchKey ?? '' },
        { storeId: salesFilter?.sectorVal?.[0]?.value ?? '' },
        {
          orderDate: salesFilter.orderDateVal
            ? formatDateByTimezone(new Date(salesFilter.orderDateVal))
            : '',
        },
        { orderStatus: salesFilter.orderStatusVal ?? '' },
        { saleTypeRaw: salesFilter.saleType ?? '' },
        { paymentTypeRaw: salesFilter.paymentType ?? '' },
      ];

      filterData.filters = filterData.filters.filter((filter) => {
        const key = Object.keys(filter)[0];
        const value = filter[key];
        return value !== '' && value !== null && value !== undefined;
      });

      /**
       * Sort
       */
      if (salesFilter.orderByVal) {
        let sortOrder = "desc";
        if (salesFilter.orderByVal === "orderDateAsc") {
          sortOrder = "asc";
        } else if (salesFilter.orderByVal === "orderDateDesc") {
          sortOrder = "desc";
        }

        // eslint-disable-next-line array-callback-return
        filterData.sort.map((_) => {
          if (_.field === "timestampDateTime") {
            _.order = sortOrder;
          }
        })
      }
    try {
      const res = await APIEndpoint.post("orders/process",JSON.stringify(filterData),{ signal: newAbortSignal("orderListAPI", 5000)});
      if(res && res.items && res.items.length>0 && viewIcon){
        return res;
    }else if(res.items && res.items.length===0){
      setMessage(undefined);
    }
    } catch (error) {

    }

    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [salesFilter]
  );

  const getSectorList = useCallback(() => {

    try {
          APIEndpoint.get("stores/byPage?" + objectToQueryString(sectorPageObj)).then(
      (resp) => {

        setSectorPageObj({ ...sectorPageObj, page: sectorPageObj.page + 1 });
        const list = [];
        if (resp.result.length > 0) {
          // eslint-disable-next-line array-callback-return
          resp.result.map((_) => {
            list.push({ value: _.id, id: _.id, label: _.value });
          });

          setSectorsList(list);
        }
      }
    ).catch(err=>{
    });
    } catch (error) {

    }


    return false;
  }, [sectorPageObj]);

  const onSectorChange = (e) => {
    setSalesFilter({ ...salesFilter, sectorVal: [e] });
    abortEarlierRequest("orderListAPI");
  };
  const onOrderByChange = (e) => {
    setSalesFilter({ ...salesFilter, orderByVal: e.target.value });
    abortEarlierRequest("orderListAPI");
  };

  const onSearchChange = (e) => {
    setSalesFilter({ ...salesFilter, searchKey: e.target.value });
  };

  const handleFilterOrderDateChange = (e) => {
    setSalesFilter({ ...salesFilter, orderDateVal: e.target.value });
    abortEarlierRequest("orderListAPI");
  };
  const handleFilterOrderStatusChange = (e) => {
    setSalesFilter({ ...salesFilter, orderStatusVal: e.target.value });
    abortEarlierRequest("orderListAPI");
  };
  const onSaleTypeChange = (e) => {
    const value= e?.value || ''
    setSalesFilter({ ...salesFilter, saleType:value });
    abortEarlierRequest("orderListAPI");
  };
  const onPaymentTypeChange = (e) => {
    setSalesFilter({ ...salesFilter, paymentType: e.target.value });
    abortEarlierRequest("orderListAPI");
  };

  const loadReportTypes = async () => {
    //, { signal: newAbortSignal('reportTypesAPI', 5000) }
    try {
        const resp = await DFPAPIEndpoint.get("reports/reportTypes");
    if (resp.result.length > 0) {
      const options = [{ key: 0, label: "Select", value: "", id: "" }];
      resp.result.map((fieldValue, index) => {
        options.push({
          key: index + 1,
          label: `${fieldValue.value}`,
          value: `${fieldValue.id}`,
          id: `${fieldValue.id}`,
        });

        return fieldValue;
      });

      setReportTypes(options);
    }
    } catch (error) {

    }

  };

  const showToast = () => {
    toast.dismiss();
      if (state.message) {
      toast.error(state.message, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: false,
        autoClose: 3800,
        style: {
          backgroundColor: '#d9534f',
          color: '#fff',
          borderRadius: '8px',
          fontSize: '1rem',
          width:'30rem'
        }
      });
    }
  };
  const onDownloadReports = async (e) => {
    const action = { value: "downloadReportPopup" };
    onActionInner(e, action, {});
  };

  const onActionInner = async(e, action, row) => {
    const {id}=row;
    setButtonId(id)
    ReactDOM.flushSync(() => {
      let updatedEditFields = [];

      if (action.value === "viewItems") {
        setModalTitle("Order No - " + row.orderNo);

        updatedEditFields = [
          {
            label: "View Order Details",
            type: "viewSalesDetails",
            attribute: "items",
          },
        ];
        updatedEditFields = updatedEditFields.filter((row) => {
          if (row.type === "viewSalesDetails") {
            row.value = row;
          }
          return row;
        });

        setModalCustomButtons([
          /**
           * Buttons
           */
          {
            label: "Close",
            attribute: "button",
            type: "button",
            disabled: false,
            className: "close-button",
            action: (e) => {
              console.log("ModalClosed.");
              onClose();
              return false;
            },
          },
        ]);

        setEditFormFields([...updatedEditFields]);

        setState((_prev) => {
          return { ..._prev, selected: { ...row, action: action.value } };
        });
      } else if (action.value === "downloadReportPopup") {
        setState((_prev) => {
          return { ..._prev, selected: { ...row, action: action.value } };
        });
      } else if (action.value === "downloadInvoices") {

        const linkTxt = action.title;
        APIEndpoint.post(
          "downloads/invoice",
          { orderId: row.id },
          { Accept: MIMETypes.pdf }
        )
          .then((resp) => {
            if (resp.status === "scheduled") {
             setIsLoadingInvoice(true)

          checkDownloadStatus(resp.id, e).then((res)=>{
            const {data}=JSON.parse(res.message)
          if(!data.success){
            setState((prev)=>({...prev,message:data.error?data.error?.title:data.message}))
          }
          setIsLoadingInvoice(false)
            }).catch((error)=>{
              setIsLoadingInvoice(false)

            });
            } else {
             setIsLoadingInvoice(false)
              updateButtonTxtStatus(true, e, linkTxt, false);
            }
          })
          .catch((error) => {
         setIsLoadingInvoice(false);

            console.error(
              "Log: Error occured while downloading invoice:",
              error
            );
            updateButtonTxtStatus(false, e, "Failed!", false, {
              defaultButtonText: linkTxt,
              className: "failedCls",
            });
          });
      }
    });
  };

  const onClose = () => {
    setState((_prev) => {
      return { ..._prev, selected: false };
    });
  };

  const onModalFormInputChange = (e, newFormData) => {
    const { name, value } = e.target;

    let newUpdates = modalFormData ? { ...modalFormData } : {};
    newUpdates[name] = value ?? "";

    setModalFormData({ ...newFormData });
  };

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
        <div className="flexRow width100 margBot10 margTop8 justifyContentSpaceBetween">
        <div className="width100Menu justifyContentCenter flexRow">
        <div className="margLeft margBot10 margTop8  underline">
              <span>
                <img
                  className="icon-size"
                  alt={t("filters.searchText")}
                  src={searchIcon}
                />
              </span>
              <span>
                <input
                  className="search"
                  onChange={onSearchChange}
                  type="search"
                  placeholder={t("filters.searchText") + " Order Number "}
                  value={salesFilter.searchKey}
                />
              </span>
            </div>
        </div>

        </div>

          <div className="flexRow width100 justifyContentSpaceBetween alignItemsCenter">
           <div className=" flexRow gap10 width100 justifyContentFlexStart alignItemsCenter">
           {salesFilter.sectorVal ? (<div className='orderBy-div m-2 margLeft'>
            <Select
              options={sectorList}
              defaultValue={salesFilter.sectorVal[0]?.label ? salesFilter.sectorVal[0]?.label : ''}
              value={sectorList?.filter(function (option) {
                return (
                  salesFilter.sectorVal.length && salesFilter.sectorVal[0]&&
                  salesFilter.sectorVal.find((sc) => sc.label === option.label)
                );
              })}
              onChange={onSectorChange}
              styles={customSelSearch((themedColor))}
              isOpenMenu={state.isOpenMenu}
              placeholder="Search Sectors"
              isSearchable={true}
              isClearable={true}
              className="selectMenu-meals-reconcilled"
            />
          </div>):<></>}

              <button className="orderBy-div m-2 margLeft">
                <select
                  className="select-item darkBlue-bg"
                  onChange={onOrderByChange}
                  value={salesFilter.orderByVal}
                  id="orderById"
                >
                  {OrderByFilters.map((_) => {
                    return (
                      <option key={_.value} value={_.value}>
                        {_.label}
                      </option>
                    );
                  })}
                </select>
              </button>

              <button className="orderStatus-div m-2">
                <select
                  className="select-item darkBlue-bg"
                  onChange={handleFilterOrderStatusChange}
                  value={salesFilter.orderStatusVal}
                  id="orderStatusId"
                >
                  <option key={""} value={""}>
                    Order Status
                  </option>
                  {ORDER_STATUS_LIST.map((_) => {
                    return (
                      <option key={_.key} value={_.key}>
                        {_.value}
                      </option>
                    );
                  })}
                </select>
              </button>

              <button className="saleType-div m-2">
              <CustomSelect
                options= {ORDER_SALE_TYPE_LIST_DYNAMIC}
                value={ORDER_SALE_TYPE_LIST_DYNAMIC.find(function(option) {
                  return salesFilter?.saleType && salesFilter.saleType === option.value
                })}
                onChange={onSaleTypeChange}
                placeHolder="Search Sales Type"
              />
              </button>

              <button className="paymentType-div m-2">
                <select
                  className="select-item darkBlue-bg"
                  onChange={onPaymentTypeChange}
                  value={salesFilter.paymentType}
                  id="paymentTypeId"
                >
                  <option key="" value="">
                    Payment Type
                  </option>
                  {ORDER_PAYMENT_TYPE_LIST.map((_) => {
                    return (
                      <option key={_.key} value={_.value}>
                        {_.label}
                      </option>
                    );
                  })}
                </select>
              </button>

              <div className="flexRow m-2 margLeft">
              <NGODatePicker
                className="orderByDateInp"
                value={salesFilter.orderDateVal?new Date(salesFilter.orderDateVal):""}
                name="filterOrderDate"
                style={{border:'1.48px solid #fff'}}
                placeholder={"DD-MM-YYYY"}
                onChange={handleFilterOrderDateChange}
                dateformat="dd-mm-yyyy"
                isClearable
              />
            </div>
            { downloadRecon ?  <div title="Download Reports" className="flexRow justifyContentCenter alignItemsCenter margTop8">
        <button className="download dropdownStyle1-TextMedium" onClick={(e) => {onDownloadReports(e)}}>
              <span>
              <img className="download__banner_icon-size mt-1" alt="Download Reports" src={downloadMasterIcon}/>

              </span>
            </button>
        </div>:<></>}

           </div>
          </div>

        <div  className='flexCol full-flex'>
          <DataGrid
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            getRows={fetchOrders}
            rowSelection="multiple"
            columnResize={true}
            resetDataSource={isReloadTableData}
            noResultsMessage={message}
          /></div>

        </>
      }
      {state &&
      Boolean(state.selected) && downloadRecon &&
      state.selected?.action === "downloadReportPopup" ? (
        <>
          <SalesReportsDownloadComponent
            sectorList={sectorList}
            onClose={() => {
              onClose();
            }}
            checkDownloadStatus={checkDownloadStatusUtil}
          />
        </>
      ) : null}
      <ToastContainer/>
      {state &&
      Boolean(state.selected) && viewRecon &&
      state.selected?.action === "viewItems" ? (
        <EditModal
          className="salesPageModal"
          title={modalTitle}
          customModalStyle={modelStyle}
          onClose={onClose}
          modalFormStatusObj={modalFormStatusObj}
          modalCustomButtons={modalCustomButtons}
          fields={editFormFields.map((elt) => {
            if (state.selected.action === "viewItems") {

              return { ...elt, initialValue: state.selected ?? "" };
            } else {
              return { ...elt, initialValue: "" };
            }
          })}
          showFieldsInColumn={true}
          onChange={(e, updated) => {
            setUpdatedFormFieldValues(updated);

            if (typeof e === "string") {

            } else {
              onModalFormInputChange(e, updated);
            }
          }}
        />
      ) : null}
    </div>
  );
};